import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { utils, EventObserver } from '@costar/theme-ui';
import React, { useMemo } from 'react';

var _utils$createContext = utils.createContext({
    strict: false,
    name: 'TransferListContext'
  }),
  _utils$createContext2 = _slicedToArray(_utils$createContext, 2),
  ContextProvider = _utils$createContext2[0],
  useTransferListContext = _utils$createContext2[1];
var TransferListContextProvider = function TransferListContextProvider(props) {
  var children = props.children;
  var context = useMemo(function () {
    var revertChangeEventObserver = new EventObserver("transfer-list-revert-change");
    return {
      revertChangeEventObserver: revertChangeEventObserver
    };
  }, []);
  return /*#__PURE__*/React.createElement(ContextProvider, {
    value: context
  }, children);
};

export { TransferListContextProvider, useTransferListContext };
//# sourceMappingURL=transfer-list-context.esm.js.map
